import { parseEntities, parseNumericId } from '@/shared/converters/commonConverters';
import { parseMoment } from '@/shared/converters/dateConverters';
import { parseLocation } from '@/vehicle/converters/locationConverters';
import JobItem, { JobPartsData } from '../models/JobItem';

const SCHEMA = {
  id: 'id',
  description: 'description',
  code: 'code',
  jobId: (data: any) => parseNumericId(data.job?.id),
  type: 'type',
  createdOn: (data: any) => parseMoment(data.createdOn),
  deletedOn: (data: any) => parseMoment(data.deletedOn),
  quantity: 'quantity',
  stockStatus: 'stockStatus',
  stockLocation: parseLocation,
  pickingStatus: 'pickingStatus',
};

export function parseJobItems(data: any): Array<JobItem> {
  return parseEntities(data, SCHEMA, JobItem);
}

export function formatJobPartsData(data: JobPartsData): any {
  return {
    partsPickingLocation: data.location,
    items: data.items,
  };
}
